export default "__VITE_ASSET__D8nV$kyE__"